// extracted by mini-css-extract-plugin
export var bannerDescription = "p_4";
export var bannerHeadline = "p_T";
export var bannerItem = "p_W";
export var bannerList = "p_V";
export var bannerWrapper = "p_S";